<div class="modal-header">
  <h3 class="modal-title">
    <span class="fw-700">Feedback da Aula Experimental</span> 🚀
  </h3>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="dismissModal()"
  >
    <span aria-hidden="true"><i class="fal fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <form
    [formGroup]="feedbackForm"
    novalidate
    class="needs-validation"
    (ngSubmit)="onSubmit()"
  >
    <div id="panel-feedback" class="panel">
      <div class="panel-hdr">
        <h4 class="text-primary fw-700">Sua Opinião é Importante!</h4>
      </div>
      <div class="panel-container show">
        <div class="panel-content">
          <!-- Campos ocultos para studentId e studentClassesCourseId -->
          <input type="hidden" formControlName="studentId" />
          <input type="hidden" formControlName="studentClassesCourseId" />

          <!-- Conteúdo Atrativo e Explicativo AQUI -->
          <div class="mb-4 text-center">
            <h4 class="fw-700 text-primary mb-2">
              Sua Experiência Importa! ✨
            </h4>
            <p class="text-muted">
              Que ótimo que você realizou sua aula experimental conosco! Sua
              perspectiva é <strong class="fw-700">crucial</strong> para
              aprimorarmos continuamente nosso método e garantir a melhor
              experiência para você e futuros alunos. Por favor, compartilhe
              seus pensamentos e impressões sobre a aula que você acabou de
              vivenciar. Seu feedback nos ajuda a construir uma escola ainda
              melhor, feita sob medida para o seu aprendizado! 🚀
            </p>
          </div>
          <!-- FIM do Conteúdo Atrativo e Explicativo -->

          <div class="form-row">
            <!-- Campo de Texto para Feedback -->
            <div class="col-12 mb-3">
              <div class="form-group">
                <label class="form-label fw-700" for="feedbackText"
                  >Nos conte sobre sua experiência
                  <span class="text-danger">*</span></label
                >
                <textarea
                  *ngIf="!preview"
                  id="feedbackText"
                  formControlName="feedbackText"
                  class="form-control"
                  rows="5"
                  [disabled]="preview"
                  maxlength="{{ maxLengthFeedback }}"
                  placeholder="Deixe seu feedback sobre a aula..."
                  [ngClass]="{
                    'is-invalid': submitted && f.feedbackText.errors
                  }"
                ></textarea>
                <div class="panel-tag" *ngIf="preview">
                  {{ f.feedbackText.value }}
                </div>

                <!-- NOVO ELEMENTO: Contador de Caracteres -->
                <div class="d-flex justify-content-end mt-1">
                  <span
                    class="badge text-white"
                    [ngClass]="{
                      'badge-danger':
                        (f.feedbackText.value?.length || 0) > maxLengthFeedback,
                      'badge-primary':
                        (f.feedbackText.value?.length || 0) <= maxLengthFeedback
                    }"
                  >
                    {{ f.feedbackText.value?.length || 0 }} /
                    {{ maxLengthFeedback }} (Faltam:
                    {{
                      maxLengthFeedback - (f.feedbackText.value?.length || 0)
                    }})
                  </span>
                </div>
                <!-- FIM DO NOVO ELEMENTO -->

                <div
                  *ngIf="submitted && f.feedbackText.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.feedbackText.errors.required">
                    Por favor, escreva seu feedback.
                  </div>
                  <div *ngIf="f.feedbackText.errors.maxlength">
                    O feedback deve ter no máximo
                    {{ f.feedbackText.errors.maxlength.requiredLength }}
                    caracteres. (Atualmente:
                    {{ f.feedbackText.errors.maxlength.actualLength }})
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <div class="form-group">
                <label class="form-label fw-700" for="rating">
                  Qual sua nota para a aula (1 a 10)?
                  <span class="text-danger">*</span>
                </label>
                <input
                  *ngIf="!preview"
                  type="tel"
                  id="rating"
                  formControlName="rating"
                  class="form-control"
                  placeholder="Nota de 1 a 10"
                  [ngClass]="{ 'is-invalid': submitted && f.rating.errors }"
                />
                <h2>{{ f.rating.value }}</h2>
                <div
                  *ngIf="submitted && f.rating.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.rating.errors.required">
                    Por favor, dê uma nota para a aula.
                  </div>
                  <!-- Nova mensagem de erro baseada no CustomValidators.ratingRange -->
                  <div *ngIf="f.rating.errors.ratingRange">
                    {{
                      f.rating.errors.ratingRange.message ||
                        "A nota deve ser um número inteiro entre 1 e 10."
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Seção de Mensagens de Erro Geral -->
    <div class="row">
      <div class="col-12">
        <div
          class="alert alert-warning alert-dismissible text-left fade show mt-3"
          role="alert"
          *ngIf="!validEntity"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
          {{ errorMessage }}
        </div>
        <hr />
        <!-- Botões de Ação -->
        <div class="row no-gutters">
          <div class="col-md-12 ml-auto text-right">
            <div class="btn-group btn-panel">
              <button
                id="js-submit-feedback-btn"
                class="btn btn-primary"
                [disabled]="submitted"
                *ngIf="!preview"
                type="submit"
              >
                <span
                  *ngIf="submitted"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Enviar Feedback
              </button>
              <button
                id="js-cancel-btn"
                class="btn btn-default"
                (click)="dismissModal()"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
